<template>
  <div id="category">
    <pageHeader></pageHeader>
    <fixedHeader></fixedHeader>
    <heroBlock></heroBlock>
    <lastShows></lastShows>
    <categoryShowsList></categoryShowsList>
  </div>

</template>

<script>

import pageHeader from '../blocks/pageHeader'
import fixedHeader from '../blocks/fixedHeader'
import categoryShowsList from '../blocks/categoryShowsList'
import heroBlock from '../blocks/heroBlock'
import lastShows from '../blocks/lastShows'

export default {
  name: 'category',
  components: {
    'pageHeader': pageHeader,
    'fixedHeader': fixedHeader,
    'categoryShowsList' : categoryShowsList,
    'heroBlock' : heroBlock,
    'lastShows' : lastShows
  },
  data () {
    return {
      slug: -1,
      loading: false
    }
  },
  mounted () {
    this.slug = this.$route.params.slug;
    TweenMax.to("#category", 2, { opacity: 1, delay: .5, ease:Power4.easeOut });
  },
  methods: {
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
#category {
  opacity: 0;

  #hero-block {
    margin-top: 188px;

    &.laboratorio-de-curadoria {
      padding-top: 294px;
    }
  }

  #last-shows {
    position: relative;
    margin-top: 0;
    margin-bottom: 0;
    padding: 85px 0;

    .bg {
      display: block;
      background-color: #e7e7e9;
    }
  }

  #shows-list {

  }
}

@include max-screen($medium) {
  #category {
    #last-shows {
      padding-left: 85px;
      padding-right: 85px;
    }

    #hero-block {
      padding-left: 50px;
      padding-right: 50px;
    }
  }
}

@include max-screen(1080px) {
  #category {
    #hero-block {
      margin-top: 168px;
      padding-top: 120px;

      &.laboratorio-de-curadoria {
        padding-top: 222px;
      }
    }
  }
}

@include max-screen($small) {
  #category {
    #last-shows {
      padding-top: 50px;
      padding-bottom: 50px;
    }
    #hero-block {
      margin-top: 158px;
      padding-top: 100px;
      padding-bottom: 50px;

      &.laboratorio-de-curadoria {
        padding-top: 187px;
      }
    }
  }
}

@include max-screen($xsmall) {
  #category {
    #last-shows {
      padding-left: 50px;
      padding-right: 50px;

      .last-show-item {
        &:nth-child(1) img,
        &:nth-child(2) img,
        &:nth-child(3) img {
          height: 200px;
        }
      }
    }
    #hero-block {
      margin-top: 122px;
      padding-left: 50px;
      padding-right: 50px;
      padding-top: 70px;

      h2 {
        font-size: 12vw;
      }

      &.laboratorio-de-curadoria {
        padding-top: 122px;
      }
    }
  }
}

@include max-screen($xxsmall) {
  #category {
    #hero-block {
      margin-top: 82px;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 60px;

      &.laboratorio-de-curadoria {
        padding-top: 100px;
      }

      h2 {
        padding: 0;
      }

      .bg {
        left: 0;
        width: 100%;
      }
    }

    #last-shows {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Category.vue